import {ClickableWrapper} from "#/src/components/ClickableWrapper";
import eye from "#/src/assets/svg/eye.svg";
import {useData} from "vike-react/useData";
import {ApiLivestreamData, ApiStreamerYouTubeVideo} from "#/src/definitions/ApiDefinitions";
import {AttachmentNamespace, Attachments} from "#/src/utils/attachment-storage";
import {truncateTitle} from "#/src/utils/string-utils";
import {DataWrapped} from "#/src/definitions/AppDefinitions";

export function YoutubeVideos() {
  const {data: livestreamData} = useData() as DataWrapped<ApiLivestreamData>;
  if (livestreamData.streamer.youTubeVideos.length == 0) {
    return <></>
  }
  return <section className="video-page youtube-page my-6">
    <div className="container-xxl">
      <div className="row">
        <div className="col-xl-12">
          <div className="title-flex mb-6">
            <h2 className="basic-headline">Youtube</h2>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        {livestreamData.streamer.youTubeVideos.map((video: ApiStreamerYouTubeVideo) => {
          return <div key={video.id} className="col-xl-3 col-sm-6 col-md-6">
            <ClickableWrapper onClick={() => window.open(`https://www.youtube.com/watch?v=${video.videoId}`, "_blank")}>
              <article className="article-card">
                <figure className="article-img article-img-xl">
                  <img src={video.thumbnailUrl} alt={video.title}/>
                </figure>
                <div className="article-content">
                  <a href="#" className="article-link">
                    {truncateTitle(video.title)}
                  </a>
                  <div className="article-author mt-2">
                    <div className="author">
                      <img alt={livestreamData.streamer.username} src={Attachments.getUrl(AttachmentNamespace.STREAMER, livestreamData.streamer)} className={"avatar avatar-20"}/>
                      <a href="#" className="author-link">{livestreamData.streamer.username}</a>
                    </div>
                    <div className="article-date">
                      <img src={eye} alt={"Odsłon"} className={"me-1"}/>
                      <span>{video.views} odsłon</span>
                    </div>
                  </div>
                </div>
              </article>
            </ClickableWrapper>
          </div>
        })}
      </div>
    </div>
  </section>
}